import { createPinia } from "pinia"
import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import RouterInterceptor from './router/router-interceptor'
import './styles/main.scss'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(RouterInterceptor)
app.mount("#app")
